import React from "react";
import { Layout, Menu, Skeleton, Badge, Drawer } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { size, times, map, intersection, get, filter, concat } from "lodash";
import userlogo from "../assets/tymeplushrlogo.svg";
import _map from "lodash/map";
import logo from "../assets/tymeplushrlogo.svg";
import COLORS from "common/Colors";
import Icon from "../atoms/Icon";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  getUserRoleId,
  getLoadingDataFirstTime,
  getUnreadChatMessageList,
  getDepartmentUserList,
  getUserInfo,
  getUserList,
  getMenuList,
  getClientid,
  getRoleList,
  getUserRole
} from "redux/selectors";
import { DEVICE } from "common/Device";

const { Item, SubMenu } = Menu;

const StyledLogo = styled.div`
  height: 70px;
  width: 80px;
  margin: 5px 15px 20px;
  text-align: center;
  background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
  img {
    margin-top: 5px;
  }
  @media ${DEVICE.tablet} {
    height: 25px;
    margin-bottom: 15px;
    img {
      height: 25px !important;
    }
  }
`;

const StyledSubMenu = styled(SubMenu)`
     background: ${COLORS.SIDEBAR};
     color: ${COLORS.TEXT.SECONDARY} !important ;

  svg {
      color: ${COLORS.TEXT.SECONDARY};
      fill: ${COLORS.TEXT.SECONDARY};
   }

   .travel-icon{
     fill: #c0cde200 !important;
   }
`;

const StyledDrawer = styled(Drawer)`
    
  .ant-drawer-header {
    background: ${COLORS.SIDEBAR};
    border: none;
  }
  .ant-menu.ant-menu-dark, .ant-menu-dark .ant-menu-sub, .ant-menu.ant-menu-dark .ant-menu-sub {
    color: ${COLORS.TEXT.SECONDARY};
      background: ${COLORS.SIDEBAR};
  }
  .ant-drawer-close{
    color: ${COLORS.TEXT.SECONDARY};
  }
  .ant-drawer-body{
    ::-webkit-scrollbar-thumb {
      background-color: #3B5A86;
      border-radius: 6px;
      font-size: 16px;
    }
    ::-webkit-scrollbar-track {
       background-color: #002862; 
    }
  }
  
`;


const StyledMenuItem = styled(Item)`
  vertical-align: middle;
  border-radius: 10px;
  width: 100%;
  background: ${COLORS.SIDEBAR};
  color: ${COLORS.TEXT.SECONDARY} !important ;

  svg {
      color: ${COLORS.TEXT.SECONDARY};
      fill: ${COLORS.TEXT.SECONDARY};
   }
   path{
    color: ${COLORS.TEXT.SECONDARY};
   }
   .MuiSvgIcon-root {
    color: ${COLORS.TEXT.SECONDARY} !important;
  }

  &:after {
    border-right: 3px solid
      ${(props) => (props.selected ? `${COLORS.PRIMARY}` : `${COLORS.SIDEBAR}`)} !important;
  }
  &.ant-menu-dark .ant-menu-item > span > a{
    color:#FFFFFFA6;
  }
  &.ant-menu-item-selected {
    color:  ${(props) =>
    props.selected ? `${COLORS.WHITE}` : '#FFFFFFA6'};
    background-color: ${(props) =>
    props.selected ? `${COLORS.PRIMARY}` : "inherit"} !important;
    .anticon,
    a,
    svg {
      color: ${COLORS.TEXT.SECONDARY};
      fill: ${(props) =>
    props.selected ? `${COLORS.WHITE}` : `${COLORS.WHITE}`};
    }
  }
`;

const StyledMenuSkeletonContainer = styled.div`
  text-align: center;
  padding: 10px 20px;
  .ant-skeleton {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`;
const Container = styled.div`
 color: ${COLORS.TEXT.SECONDARY};
 ::-webkit-scrollbar-thumb {
  background-color: #3B5A86;
  border-radius: 6px;
  font-size: 16px;
}
.ant-layout-sider-children{
  background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
  margin: 0;
  color: ${COLORS.TEXT.SECONDARY};
}

.ant-menu-submenu-title > .anticon {
  color:  ${COLORS.TEXT.SECONDARY}; /* Set your desired color */
  fill:  ${COLORS.TEXT.SECONDARY};
}
.ant-menu{
  font-size: 14px;
  background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
  color: ${COLORS.TEXT.SECONDARY};
}
.ant-menu-dark .ant-menu-inline.ant-menu-sub {
    background: ${COLORS.SIDEBAR};
}
  overflow-y: auto;
  overflow-x: hidden;
  .sidemenu {
    display: none;
  }
  .hidemenu {
    display: flex;
    width: max-content;
    height: 100%;
    padding: 15px;
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    flex-direction: column;
    justify-content: space-between;
    p {
      font-weight: bold;
      padding-left: 5%;
    }
  }
  .hidemenu1 {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: space-between;
    background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    p {
      font-weight: bold;
      padding-left: 5%;
      margin-top: 10%;
    }
  }
  @media ${DEVICE.tablet} {
    .sidemenu {
      width: 150px;
      height: 100vh;
      display: flex;
      justify-content: center;
      position: fixed;
      top: 110px;
      transition: 350ms;
      z-index: 20;
      background: ${COLORS.SIDEBAR} 0% 0% no-repeat padding-box;
    }
    .hidemenu {
      display: none;
      padding: 10px;
    }
  }
`;

const StyledBadge = styled(Badge)`
  left: 10px;
  top: 4px;
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  .ant-badge-dot {
    width: 10px;
    height: 10px;
    animation: blinker 1s linear infinite;
  }
`;

const { Sider } = Layout;
const SideBar = ({
  defaultKey,
  activePage,
  collapsed,
  setPageTitle,
  userRoleId,
  isLoadingDataFirstTime,
  unreadChatMessageList,
  open,
  onClose,
  userInfo,
  userList,
  menuList,
  clientId,
}) => {


  let Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;

  Menulist = Array.isArray(Menulist) ? Menulist : [];

  const filtermenulist = (Menulist && Menulist.filter(
    (data) =>
      data.key !== "managerdashboard" &&
      data.key !== "hrdashboard" &&
      data.key !== "teamcalendar" &&
      data.key !== "allcalendar"
  )) || [];

  const myTeamCalendarAccess = (Menulist && Menulist.filter(
    (data) =>
      data.key === "teamcalendar" ||
      data.key === "allcalendar"
  )) || [];

  const myTeamDashBoardAccess = (Menulist && Menulist.filter(
    (data) =>
      data.key === "hrdashboard" ||
      data.key === "managerdashboard"
  )) || [];

  const canViewCalendar = myTeamCalendarAccess.some(menu => menu.permission.view);
  const canViewDashboard = myTeamDashBoardAccess.some(menu => menu.permission.view);

  const menuSkeleton = (key) => (
    <Skeleton.Input block={true} active={true} size="small" key={key} />
  );
  const location = useLocation();
  const pathname = location.pathname;

  const unreadDot = () => {
    var hrUser = filter(userList, { roleid: 1 });

    if (userRoleId === 2) {
      let result = map(
        concat(
          filter(userList, {
            departmentid: get(userInfo, "staff_department_id", ""),
          }),
          hrUser
        ),
        (e) => e.userid
      );
      result = intersection(result, unreadChatMessageList);
      return size(result) ? true : false;
    }
    return size(unreadChatMessageList) ? true : false;
  };

  const logoStyle = {
    height: collapsed ? "55px" : "70px",
    marginTop: collapsed ? "15px" : "0px",
    marginLeft: collapsed ? "-40px" : "",
  };

  const containerStyle = {
    height: "100vh",
    background: `${COLORS.SIDEBAR}`,
  };

  const drawerStyle = {
    padding: "0px",
    background: `${COLORS.SIDEBAR} 0% 0% no-repeat padding-box`
  };
  const clientStyle = collapsed ? { fontSize: "8px" } : { fontSize: "12px" };

  return (
    <Container style={containerStyle}>
      <div className="hidemenu">
        <Sider trigger={null} collapsible collapsed={collapsed}>
          <Link to={userRoleId === "1" ? `ownerdashboard` : `dashboard`} onClick={() => setPageTitle("")}>
            <StyledLogo>
              <img className="mb-3 pb-2"
                style={logoStyle}
                src={(userRoleId === "1") ? logo : userlogo}
                alt="Tymeplus"
              />
            </StyledLogo>
          </Link>
          {isLoadingDataFirstTime && (
            <StyledMenuSkeletonContainer>
              {times(10, (ind) => menuSkeleton(ind))}
            </StyledMenuSkeletonContainer>
          )}

          {!isLoadingDataFirstTime && (
            <Menu
              theme="dark"
              mode="inline"
              defaultSelectedKeys={[activePage]}
              defaultOpenKeys={[defaultKey]}
            >
              {_map(
                filtermenulist?.filter(
                  (menu) =>
                    (menu?.access && menu.icon !== "") ||
                    (menu.key === "mycalendar" && canViewCalendar) ||
                    (menu.key === "dashboard" && canViewDashboard)
                ),
                (menu) => {
                  const isSelected = pathname.substr(1) === menu.path;
                  return menu?.subMenu && menu?.subMenu?.length > 0 ? (
                    <StyledSubMenu
                      key={menu?.key}
                      title={menu?.title}
                      icon={menu?.icon && <Icon className={ menu?.icon === 'travel' &&  'travel-icon'} name={menu?.icon} />}
                    >
                      {_map(
                        menu?.subMenu.filter((submenu) => submenu?.access),
                        (submenu) => {
                          return submenu?.subMenu &&
                            submenu?.subMenu?.length > 0 ? (
                            <StyledSubMenu
                              key={submenu?.key}
                              icon={
                                submenu?.icon && <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                              }
                              title={submenu?.title}
                            >
                              {_map(
                                submenu?.subMenu.filter(
                                  (submenu) => submenu?.access
                                ),
                                (submenu) => {

                                  return (
                                    <StyledMenuItem
                                      collapsed={collapsed ? "true" : "false"}
                                      key={submenu?.key}
                                      icon={
                                        submenu?.icon && (
                                          <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                                        )
                                      }
                                      onClick={() =>
                                        setPageTitle(submenu?.title)
                                      }
                                      selected={
                                        location?.pathname.substr(1) === ""
                                          ? false
                                          : true
                                      }
                                    >
                                      <Link to={`/${submenu.path}`}>
                                        {submenu?.title}
                                      </Link>
                                      <StyledBadge
                                        dot={
                                          menu?.path === "team" && unreadDot()
                                        }
                                      />
                                    </StyledMenuItem>
                                  );
                                }
                              )}
                            </StyledSubMenu>
                          ) : (
                            <StyledMenuItem
                              collapsed={collapsed ? "true" : "false"}
                              key={submenu?.key}
                              icon={
                                submenu?.icon && <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                              }
                              onClick={() => setPageTitle(submenu?.title)}
                              selected={
                                location?.pathname.substr(1) == ""
                                  ? false
                                  : true
                              }
                            >
                              <Link to={`/${submenu?.path}`}>
                                {submenu?.title}
                              </Link>
                              <StyledBadge
                                dot={menu?.path === "team" && unreadDot()}
                              />
                            </StyledMenuItem>
                          );
                        }
                      )}
                    </StyledSubMenu>
                  ) : (
                    <StyledMenuItem
                      key={menu?.key}
                      icon={menu?.icon && <Icon className={ menu?.icon === 'travel' &&  'travel-icon'} name={menu?.icon} />}
                      onClick={() => setPageTitle(menu?.title)}
                      // selected={
                      //   location?.pathname.substr(1) == "" ? false : true
                      // }
                      selected={isSelected}
                    >
                      <Link to={`/${menu?.path}`}>
                        {menu?.key === "mycalendar" ? "Calendar" : menu?.key === "dashboard" ? "Dashboard" : menu?.title}
                      </Link>
                      <StyledBadge dot={menu?.path === "team" && unreadDot()} />
                    </StyledMenuItem>
                  );
                }
              )}
            </Menu>
          )}
        </Sider>
        <p style={clientStyle}>Client ID : {clientId}</p>
      </div>
      <div>
        <StyledDrawer
          bodyStyle={drawerStyle}
          width={240}
          title={
            <>
              <Link to={`dashboard`}>
                <img
                  src={userRoleId == 1 ? logo : userlogo}
                  width={120}
                  alt="Tymeplus"
                />
              </Link>
            </>
          }
          placement="left"
          onClose={onClose}
          open={open}
        >
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[activePage]}
            defaultOpenKeys={[defaultKey]}
          >
            {_map(
               filtermenulist?.filter(
                  (menu) =>
                    (menu?.access && menu.icon !== "") ||
                    (menu.key === "mycalendar" && canViewCalendar) ||
                    (menu.key === "dashboard" && canViewDashboard)
                ),
              (menu) => {
                return menu?.subMenu && menu?.subMenu?.length > 0 ? (
                  <StyledSubMenu
                    key={menu?.key}
                    icon={menu?.icon && <Icon className={ menu?.icon === 'travel' &&  'travel-icon'} name={menu?.icon} />}
                    title={menu?.title}
                  >
                    {_map(
                      menu?.subMenu.filter((submenu) => submenu?.access),
                      (submenu) => {
                        return submenu?.subMenu &&
                          submenu?.subMenu?.length > 0 ? (
                          <StyledSubMenu
                            key={submenu?.key}
                            icon={
                              submenu?.icon && <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                            }
                            title={submenu?.title}
                          >
                            {_map(
                              submenu?.subMenu.filter(
                                (submenu) => submenu?.access
                              ),
                              (submenu) => {
                                return (
                                  <StyledMenuItem
                                    collapsed={collapsed ? "true" : "false"}
                                    key={submenu?.key}
                                    icon={
                                      submenu?.icon && (
                                        <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                                      )
                                    }
                                    onClick={() => {
                                      setPageTitle(submenu?.title);
                                      onClose();
                                    }}
                                    selected={
                                      location.pathname.substr(1) == ""
                                        ? false
                                        : true
                                    }
                                  >
                                    <Link to={`/${submenu.path}`}>
                                      {submenu?.title}
                                    </Link>
                                    <StyledBadge
                                      dot={menu?.path === "team" && unreadDot()}
                                    />
                                  </StyledMenuItem>
                                );
                              }
                            )}
                          </StyledSubMenu>
                        ) : (
                          <StyledMenuItem
                            collapsed={collapsed ? "true" : "false"}
                            key={submenu?.key}
                            icon={
                              submenu?.icon && <Icon className={ submenu?.icon === 'travel' &&  'travel-icon'} name={submenu?.icon} />
                            }
                            onClick={() => {
                              setPageTitle(submenu?.title);
                              onClose();
                            }}
                            selected={
                              location?.pathname.substr(1) == "" ? false : true
                            }
                          >
                            <Link to={`/${submenu?.path}`}>
                              {submenu?.title}
                            </Link>
                            <StyledBadge
                              dot={menu?.path === "team" && unreadDot()}
                            />
                          </StyledMenuItem>
                        );
                      }
                    )}
                  </StyledSubMenu>
                ) : (
                  <>

                    <StyledMenuItem
                      key={menu?.key}
                      icon={menu?.icon && <Icon className={ menu?.icon === 'travel' &&  'travel-icon'} name={menu?.icon} />}
                      onClick={() => {
                        setPageTitle(menu?.title);
                        onClose();
                      }}
                      selected={
                        location?.pathname.substr(1) === "" ? false : true
                      }
                    >
                      <Link to={`/${menu?.path}`}>{menu?.key === "mycalendar" ? "Calender" : menu?.key === "dashboard" ? "Dashboard" : menu?.title}</Link>
                      <StyledBadge
                        dot={
                          menu?.path === "team" && size(unreadChatMessageList)
                            ? true
                            : false
                        }
                      />
                    </StyledMenuItem>

                  </>
                );
              }
            )}
          </Menu>
        </StyledDrawer>
      </div>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  isLoadingDataFirstTime: getLoadingDataFirstTime(state),
  unreadChatMessageList: getUnreadChatMessageList(state),
  departmentUserList: getDepartmentUserList(state),
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  menuList: getMenuList(state),
  clientId: getClientid(state),
  roleList: getRoleList(state),
  UserRoleId: getUserRoleId(state),
  roleId: getUserRoleId(state),
  role: getUserRole(state)
});

export default connect(mapStateToProps, null)(SideBar);
